import Footer from "../../footer"
import NavBar from "../../nav"

const SafetyBoard = () => {
  return <div className='all-manuals'>
    <NavBar />
    <div>
	<section className="clean-block pfa-content clearfix">
			<div className="divider sections">
				<h1>Safety Board</h1>
				<div className="headline-divider sections"></div>
				<h2>Assessing Risk. Developing Standards.</h2>
			</div>	
		</section>
		<section className="clean-block clearfix">	
			<div className="container content-container edict-container">
				<div className="prose-header">The Mission</div>
				<div className="prose">Fly Compliant, LLC has assembled a Safety Board from our diverse user group. We have included business professional as well as safety experts to participate. As a group the board analyzes SMS data from LevelFlight then determines a plan of action and follow-up.</div>	
				<div className="prose not-first">The benefit of the board is as a group acting to address safety standards to determine SOPs and changes to training.  The board proactively develops a risk-profile from assessing risk for each phase of flight. The result is forward looking risk assessment for all users.</div>	
				<div className="prose not-first">The ultimate objective of the board is to determine the effectiveness of the SMS processes. Annually the board will determine the effectiveness of the SMS by examining past years events, then set the Goals and Objectives for the user group over the following year.</div>
			</div>
		</section>
    </div>
    <Footer />
  </div>
}

export default SafetyBoard